import * as React from 'react';
import styled from 'styled-components';

import CoreChangerButton from '../components/CoreChangerButton';
import { LocalStorageKey } from '../enums/local-storage-key.enum';
import { CoreChangerEntity } from '../models/core-changer.model';

const StCoreChangerConatiner = styled.span`
  position: fixed;
  right: 40px;
  bottom: 16px;
`;

class CoreChangerConatiner extends React.Component {
  render() {
    const entities: CoreChangerEntity[] = [
      {
        name: 'Logo',
        firstLetter: 'L',
        changers: [
          {
            copy: 'Please submit new logo image URL here',
            localStorageKey: LocalStorageKey.Logo,
          },
        ],
      },
      {
        name: 'Title',
        firstLetter: 'T',
        changers: [
          {
            copy: 'Please submit new title(English) here',
            localStorageKey: LocalStorageKey.Title_en,
          },
          {
            copy: 'Please submit new title(Korean) here',
            localStorageKey: LocalStorageKey.Title_ko,
          },
        ],
      },
      {
        name: 'Background',
        firstLetter: 'B',
        changers: [
          {
            copy: 'Please submit new background image URL here',
            localStorageKey: LocalStorageKey.Background,
          },
        ],
      },
    ];

    return (
      <StCoreChangerConatiner>
        {entities.map((entity: CoreChangerEntity, index: number) => (
          <CoreChangerButton key={index} coreChanger={entity}>
            {entity.firstLetter}
          </CoreChangerButton>
        ))}
      </StCoreChangerConatiner>
    );
  }
}

export default CoreChangerConatiner;



// WEBPACK FOOTER //
// ./src/app/dashboard/containers/CoreChanger.container.tsx